import {TskNotification} from './tsk-notification';
export class TskNotificationObjectList {
  listTskNotificationBO: TskNotification[];
}
